import * as types from './actionTypes';
import tipoPessoaApi from '../api/tipoPessoaApi'


export function ListarTipoPessoaSucess(tiposPessoa) {
    
    return { type: types.LISTAR_TIPO_PESSOA_VISIVEL, payload: tiposPessoa }
}

export function ListarTipoPessoa(data) {
    return function (dispatch) {
        return tipoPessoaApi.ListarTipoPessoa(data).then(resultado => {
            
            dispatch(ListarTipoPessoaSucess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/tipoPessoaActions.js
 **/